import React from "react";
import "../theme/SkeletonIndicators.css";

/**
 * Skeleton para tarjetas de Órdenes y Ticket Promedio (fondo blanco)
 * Muestra la estructura de la tarjeta mientras se cargan los datos
 */
export const SkeletonOrdersCard = () => {
  return (
    <div className="skeleton-orders-card">
      {/* Header */}
      <div className="skeleton-orders-header">
        <div className="skeleton-orders-icon-section">
          <div className="skeleton-icon"></div>
          <div className="skeleton skeleton-text medium" style={{ width: "140px" }}></div>
        </div>
        <div className="skeleton-orders-value-section">
          <div className="skeleton skeleton-label" style={{ width: "40px" }}></div>
          <div
            className="skeleton skeleton-amount"
            style={{ width: "80px", height: "1.5rem" }}
          ></div>
        </div>
      </div>

      {/* Body */}
      <div className="skeleton-orders-body">
        {/* Columna 1: Vs Ptto */}
        <div className="skeleton-orders-column">
          <div className="skeleton skeleton-label"></div>
          <div className="skeleton skeleton-percentage"></div>
          <div className="skeleton skeleton-amount" style={{ width: "80px" }}></div>
        </div>

        {/* Columna 2: Vs AA */}
        <div className="skeleton-orders-column">
          <div className="skeleton skeleton-label"></div>
          <div className="skeleton skeleton-percentage"></div>
          <div className="skeleton skeleton-amount" style={{ width: "80px" }}></div>
        </div>
      </div>
    </div>
  );
};
